import _ from 'lodash';

/**
 * Properties on the enrichment data entity which NOT will be included in the
 * copy.
 *
 * @type {Array}
 */
const propsToOmit = [
  'id',
  'isUpToDate',
  'referencedIFoodData',
  'ingredientEntryIds',
  'modifyDate',
  'lastModifiedBy',
  'createdBy',
  'version',
  'hash',
  'targetPublishDate',
  'targetUnpublishDate',
  'ppiDetails',
  'status'
];

/**
 * Translations on the enrichment data entity which NOT will be included in the
 * copy.
 *
 * @type {Array}
 */
const translationsToOmit = ['versionComment'];

function copyTranslations(forPath, fromLanguage, toLanguages) {
  const translations = _.omit(forPath.info[fromLanguage], translationsToOmit);
  const info = {};
  toLanguages.forEach(toLanguage => {
    info[toLanguage] = translations;
  });
  return info;
}

function copyServingInstructions(fromEnrichment, fromLanguage, toLanguages) {
  return fromEnrichment.servingInstructions.map(step => {
    const info = copyTranslations(step, fromLanguage, toLanguages);
    return {
      ...step,
      id: null,
      ppiEnrichmentId: null,
      key: `id-${Math.round(Math.random() * 1000000)}`,
      info
    };
  });
}

function copyEnrichmentData(fromEnrichment, fromLanguage, toLanguages) {
  const data = _.omit(fromEnrichment, propsToOmit);
  data.parentPpsiEnrichmentDataId = fromEnrichment.id;
  data.info = copyTranslations(data, fromLanguage, toLanguages);
  data.servingInstructions = copyServingInstructions(
    fromEnrichment,
    fromLanguage,
    toLanguages
  );
  return data;
}

function copyPpsi(fromPpsi, fromEnrichmentId, fromLanguage, toLanguages) {
  if (_.get(fromPpsi, 'inProgressPpsiEnrichmentData.id') === fromEnrichmentId) {
    return copyEnrichmentData(
      fromPpsi.inProgressPpsiEnrichmentData,
      fromLanguage,
      toLanguages
    );
  }
  if (_.get(fromPpsi, 'publishedPpsiEnrichmentData.id') === fromEnrichmentId) {
    return copyEnrichmentData(
      fromPpsi.publishedPpsiEnrichmentData,
      fromLanguage,
      toLanguages
    );
  }
  throw new Error(
    `Failed to locate PPSI Enrichment Data to base PPSI on (from enrichment with id: ${fromEnrichmentId})`
  );
}

export default copyPpsi;
